/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Grid, Card } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import ReportsBarChart from "templates/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "templates/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "templates/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
// Dashboard components
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "App";
import { DashboardAPI } from "APIs/DashboardAPI";
import MDTypography from "components/MDTypography";

function Dashboard() {
  const [dashboardData, setDashboardData] = useState();
  const userData = useContext(UserContext);
  const getDashBoardFunc = async (access_token) => {
    const response = await DashboardAPI(access_token);
    console.log(response);
    setDashboardData({ ...response });
  };

  useEffect(() => {
    if (userData?.access_token !== undefined) {
      getDashBoardFunc(userData?.access_token);
    }
  }, [userData]);
  return (
    <>
      <MDBox py={3}>
        <Grid container spacing={2} className="d-flex justify-content-center">
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="collections"
                title="Album"
                count={dashboardData?.media?.total || 0}
                percentage={{
                  amount: dashboardData?.media?.lastMonth,
                  label: " last month added",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="audiotrack"
                title="Audio"
                count={dashboardData?.audio?.total || 0}
                percentage={{
                  amount: dashboardData?.audio?.lastMonth,
                  label: "last month added",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="book"
                title="Blog"
                count={dashboardData?.blog?.total || 0}
                percentage={{
                  amount: dashboardData?.blog?.lastMonth,
                  label: "last month added",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <ComplexStatisticsCard
                    icon="accessibilitynew"
                    title="Seva"
                    count={dashboardData?.seva?.total || 0}
                    percentage={{
                      label: "Number of seva",
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ComplexStatisticsCard
                    icon="local_library"
                    title="Literature"
                    count={dashboardData?.literature?.total || 0}
                    percentage={{
                      label: "Number of literature",
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="primary"
                  title="Devotees"
                  description="Devotees chat for last 12 months"
                  date={`Total: ${dashboardData?.devotee?.total || 0}  , Last Month : ${
                    dashboardData?.devotee?.lastMonth || 0
                  }`}
                  chart={{
                    labels: dashboardData?.devotee?.last12Months?.map(
                      (item) => `${item.mm}-${item.yyyy}`
                    ),
                    datasets: {
                      label: "devotees",
                      data: dashboardData?.devotee?.last12Months?.map((item) => Number(item.count)),
                    },
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="Events"
                  description="Event chat for last 12 months"
                  date={`Total: ${
                    Number(dashboardData?.event?.upComming || 0) +
                      Number(dashboardData?.event?.endded || 0) +
                      dashboardData?.event?.running.length || 0
                  }`}
                  chart={{
                    labels: dashboardData?.event?.last12Months.map(
                      (item) => `${item?.mm}-${item?.yyyy}`
                    ),
                    datasets: {
                      label: "Events",
                      data: dashboardData?.event?.last12Months?.map(
                        (item) => Number(item.count) || 0
                      ),
                    },
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {dashboardData?.event?.running.length > 0 ? (
          <MDBox className=" w-100 d-flex justify-content-center">
            <Card className=" ps-5 pe-5 mb-3">
              <MDTypography variant="h4" fontWeight="medium">
                Running events
              </MDTypography>
            </Card>
          </MDBox>
        ) : (
          <MDBox className=" w-100 d-flex justify-content-center">
            <Card className=" ps-5 pe-5 mb-3">
              <MDTypography variant="h4" fontWeight="medium">
                No events
              </MDTypography>
            </Card>
          </MDBox>
        )}
        <MDBox>
          <Grid container spacing={3} className="d-flex justify-content-center">
            {dashboardData?.event?.running?.map((item, key) => {
              return (
                <Grid item xs={12} md={6} key={key}>
                  <OrdersOverview event={item} />
                </Grid>
              );
            })}
          </Grid>
        </MDBox>
      </MDBox>
    </>
  );
}

export default Dashboard;
